import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { getHomeStatGunStatus, getMapStaSize, } from "@/api/api-operation-service";
import i18n from "@/config/i18n";
let PiHomeMapGunStatus = class PiHomeMapGunStatus extends Vue {
    constructor() {
        // @Prop({ default: "" }) private oprPkId!: string;
        // @Watch("oprPkId")
        // "watch.oprPkId"(): void {
        //   this.getHomeStatGunStatus();
        // }
        super(...arguments);
        this.scaleData = {};
        this.scaleList = [
            {
                name: i18n.t("homeMap.smallSize"),
                pile: 10,
                prowr: 100,
                type: "mini",
                stakey: "smallSizeStaNum",
                pilekey: "smallSizePileNum",
                prowrkey: "smallSizePowerNum",
            },
            {
                name: i18n.t("homeMap.mediumSize"),
                pile: 10,
                prowr: 100,
                type: "small",
                stakey: "mediumSizeStaNum",
                pilekey: "mediumSizePileNum",
                prowrkey: "mediumSizePowerNum",
            },
            {
                name: i18n.t("homeMap.largeSize"),
                pile: 10,
                prowr: 100,
                type: "large",
                stakey: "largeSizeStatNum",
                pilekey: "largeSizePileNum",
                prowrkey: "largeSizePowerNum",
            },
        ];
        this.total = 0;
        this.gunList = [];
        this.gunColor = {
            0: "#FFC01F",
            1: "#28B2FF",
            2: "#A22E27",
            3: "#F7B6B2",
            4: "#C1C3C6",
            7: "#08C935",
            8: "#2765A7",
            9: "#18CFDB",
        };
    }
    /**
     * 获取规模统计
     */
    async getMapStaSize() {
        let ret = await getMapStaSize({});
        if (ret.status === this.$config.apiStatus) {
            let data = ret.data[0] || {};
            this.scaleData = data;
        }
    }
    /**
     * 获取充电枪状态
     */
    async getHomeStatGunStatus() {
        const ret = await getHomeStatGunStatus({});
        this.gunStatus(ret);
    }
    /**
     * 数据处理
     */
    gunStatus(ret) {
        if (ret.status == this["$config"].apiStatus) {
            let data = ret.data;
            let total = 0;
            data.map((item) => {
                // 暂时去掉预约
                total += item.value;
            });
            this.total = total;
            this.gunList = data;
        }
    }
    mounted() {
        this.getHomeStatGunStatus();
        this.getMapStaSize();
    }
};
PiHomeMapGunStatus = __decorate([
    Component({
        components: {},
    })
], PiHomeMapGunStatus);
export default PiHomeMapGunStatus;
